import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import api from '../../services/service'
// import Swal from 'sweetalert2'
const header = {
  headers: {
    'Access-Token': sessionStorage.token
    // 'Access-Token': 'aca9457564ee48728a61c3d67d06e3e1'
  }
}
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      search_keyword: '',
      title: 'จัดการผู้ใช้งาน',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      },
      modal_title: '',
      data_list: []
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.data_list.filter(userlist => {
        return (
          userlist.user_code.indexOf(text) > -1 || userlist.username.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.active = pageNumber
    },
    getList () {
      // this.$store.commit('Loading')
      let body = {
        'keyword': this.search_keyword,
        'limit': 500,
        'status': 1
      }
      // console.log(header)
      api.listUser(this.REST_URL,
        {},
        body,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    goToPage (path, code) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push({ name: path, params: { user_code: code } })
    },
    editUser (val) {
      console.log(val)
      // this.$router.push({ name: 'editusers', params: { user_code: val.user_code } })
      this.goToPage('editusers', val.user_code)
    },
    removeUser (val) {
      // this.$store.commit('Loading')
      let body = {
        'user_code': val.user_code,
        'active_status': 0
      }
      api.removeUser(this.REST_URL,
        header,
        body,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลผู้ใช้งานสำเร็จ',
              description:
                      result.message
            })
            this.getList()
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    doing () {
      alert('รอดำเนินการ')
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.zipcode = address.zipcode
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      }
    }
  },
  mounted () {
    this.$store.state.historyPage = ''
    this.checkUser()
    this.getList()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/user_list.js